import { HierarchyManager } from "../../components/HierarchyManager";
import { bpaConfig } from "./bpaConfig";

function BPAsPage() {
  return <HierarchyManager config={bpaConfig} />;
}

export default BPAsPage;
